module.exports = __webpack_public_path__ + "static/media/esimIcon.e84883ba.svg";